import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';

import { finleyAssert } from '@finley-technologies/common';

import { loginAndRedirect } from '../../packages/logged-out/hooks/useLoginFormManagement';
import { HomeRoute } from './HomeRoute';
import { SignupRoute } from './SignupRoute';

const Auth0Callback: React.FC<{}> = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  finleyAssert(token, 'Unable to get access token from SSO Authentication.');

  loginAndRedirect(token, '/');

  return <Skeleton />;
};

export const LoggedOutRouter = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomeRoute} />
      <Route exact path="/auth0-callback" component={Auth0Callback} />
      <Route exact path="/signup" component={SignupRoute} />
      <Redirect to="/" />
    </Switch>
  );
};
